export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const showModal = (type, props) => ({
  type: SHOW_MODAL,
  payload: {
    type,
    props,
  },
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});



// WEBPACK FOOTER //
// ./actions/modalActions.js